module.exports = __webpack_public_path__ + "static/media/SetUp.bdc46765.JPG";